import React from 'react';
import PropTypes from 'prop-types';
import {
    Input,
    InputGroup,
    Button,
    InputGroupAddon
} from 'reactstrap';

export class CustomSearch extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        onSearch: PropTypes.func,
        updateSearch: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.value !== this.state.value) {
            this.props.updateSearch(this.state.value);
        }
    }

    render() {
        return (
            <InputGroup className={ this.props.className } size="sm">
                <InputGroupAddon addonType="prepend" >
                    <Button outline>
                        <i className="fa fa-search fa-fw"></i>
                    </Button>
                </InputGroupAddon>
                <Input
                    onChange={(e) => { this.setState({ value: e.target.value }); }}
                    value={ this.state.value }
                    placeholder="Type to search..."
                />
                {
                    this.state.value && (
                        <InputGroupAddon addonType="append">
                            <Button
                                outline
                                onClick={() => { this.setState({value: ''}); }}
                            >
                                <i className="fa fa-fw fa-times"></i>
                            </Button>
                        </InputGroupAddon>
                    )
                }
            </InputGroup>
        )
    }
} 